import moment from 'moment';
import * as validators from './validators';

export const toJpYearDate = date => {
  const dateMoment = moment(date);
  if (!dateMoment.isValid()) {
    return '';
  }
  const list = [
    ['2019-05-01', '令和'],
    ['1989-01-08', '平成'],
    ['1926-12-25', '昭和'],
    ['1912-07-30', '大正'],
    ['1868-01-25', '明治'],
  ];
  let yearStr = null;
  for (let [start, text] of list) {
    if (dateMoment.isSameOrAfter(start)) {
      const year = dateMoment.year() - moment(start).year() + 1;
      yearStr = year == 1 ? `${text}元年` : `${text}${year}年`;
      break;
    }
  }
  return yearStr ? dateMoment.format('LL').replace(/\d{4}年/, yearStr) : dateMoment.format('LL');
};

export const toAdYearDate = (jpYearDate, zeroPadding = true) => {
  const dateMatch = jpYearDate.match(validators.jpYearRegExp);
  if (!dateMatch) {
    return '';
  }

  const jpYearNum = Number(dateMatch[2]);
  let yearStr = null;
  if (dateMatch[1].toUpperCase() === 'R' && jpYearNum > 0) {
    yearStr = `${jpYearNum + 2018}`;
  } else if (dateMatch[1].toUpperCase() === 'H' && jpYearNum > 0) {
    yearStr = `${jpYearNum + 1988}`;
  } else if (dateMatch[1].toUpperCase() === 'S' && jpYearNum > 0) {
    yearStr = `${jpYearNum + 1925}`;
  } else if (dateMatch[1].toUpperCase() === 'T' && jpYearNum > 0) {
    yearStr = `${jpYearNum + 1911}`;
  } else if (dateMatch[1].toUpperCase() === 'M' && jpYearNum > 0) {
    yearStr = `${jpYearNum + 1867}`;
  }

  const dateMoment = moment(`${yearStr}/${dateMatch[3]}/${dateMatch[4]}`, 'YYYY/MM/DD');
  if (yearStr && dateMoment.isValid()) {
    return zeroPadding ? dateMoment.format('YYYY/MM/DD') : dateMoment.format('YYYY/M/D');
  } else {
    return '';
  }
};
